export const imageIdGenerate = (userId) => {
  let u_id = userId;
  if (u_id > 30) {
    return imageIdGenerate(u_id - 30);
  } else {
    return u_id;
  }
};
